import { render, staticRenderFns } from "./UpdateExchangeRate.vue?vue&type=template&id=85cf456c&lang=html"
import script from "./UpdateExchangeRate.vue?vue&type=script&lang=js"
export * from "./UpdateExchangeRate.vue?vue&type=script&lang=js"
import style0 from "./UpdateExchangeRate.vue?vue&type=style&index=0&id=85cf456c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports